import api from "./api";
import { type Purchase, type PublishingHouse } from "../../types/database";

interface RawPH {
  id?: string;
  name?: string;
  logoUrl?: string;
  bannerUrl?: string;
  revenuePercent?: number | null;
  purchases?: Purchase[];
}

export async function getPublishingHouse(id: string): Promise<PublishingHouse> {
  const data = await api.get<unknown, RawPH>("/getPublishingHouse", {
    params: { id },
  });
  return {
    id: data.id ?? id,
    name: data.name ?? "",
    logoUrl: data.logoUrl ?? "",
    bannerUrl: data.bannerUrl ?? "",
    revenuePercent: data.revenuePercent ?? null,
    purchases: data.purchases ?? [],
  };
}

export type BrandImageType = "logo" | "banner";

/** Upload a new logo/banner for the caller's own house; returns the stored URL. */
export async function uploadBrandImage(
  file: File,
  type: BrandImageType,
): Promise<string> {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post<unknown, { url: string }>("/uploadBrandImage", fd, {
    params: { type },
  });
  return res.url;
}

/** Clear the logo/banner of the caller's own house. */
export async function deleteBrandImage(type: BrandImageType): Promise<void> {
  await api.post("/deleteBrandImage", null, { params: { type } });
}
